import React from 'react'
import {
  PAR_LEVEL_PAYWALL_HEADLINE,
  PAR_LEVEL_PAYWALL_HIGHER_TIERS_LINE,
  PAR_LEVEL_PAYWALL_STARTER_BENEFITS,
  PAR_LEVEL_PAYWALL_TRUST_LINE,
  PAR_LEVEL_PAYWALL_WORKAROUND_MESSAGE,
} from './parLevelPaywall'

const ParLevelUpgradeModalContent = () => (
  <>
    <p>
      <strong>{PAR_LEVEL_PAYWALL_HEADLINE}</strong>
    </p>
    <p>{PAR_LEVEL_PAYWALL_WORKAROUND_MESSAGE}</p>
    <p>
      <strong>Starter also includes:</strong>
    </p>
    <ul style={{ marginLeft: 20, paddingLeft: 0 }}>
      {PAR_LEVEL_PAYWALL_STARTER_BENEFITS.map(benefit => (
        <li key={benefit}>{benefit}</li>
      ))}
    </ul>
    <p>{PAR_LEVEL_PAYWALL_HIGHER_TIERS_LINE}</p>
    <p>
      <em>{PAR_LEVEL_PAYWALL_TRUST_LINE}</em>
    </p>
  </>
)

export default ParLevelUpgradeModalContent
